/* eslint-disable no-use-before-define */
import * as actionTypes from 'store/actions/actionTypes';
import { updateObject } from 'utils/utility';

const initialState = {
  loading: false,
  data: null,
  error: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.EDIT_SETTING_START:
      return editSettingtStart(state);
    case actionTypes.EDIT_SETTING_SUCCESS:
      return editSettingtSuccess(state, action);
    case actionTypes.EDIT_SETTING_FAIL:
      return editSettingtFail(state, action);
    case '@@router/LOCATION_CHANGE':
      return initialState;
    default:
      return state;
  }
};

export default reducer;

function editSettingtStart(state) {
  return updateObject(state, {
    loading: true,
    data: null,
    error: null,
  });
}

function editSettingtSuccess(state, action) {
  return updateObject(state, {
    loading: false,
    data: action.payload,
    error: null,
  });
}

function editSettingtFail(state, action) {
  return updateObject(state, {
    loading: false,
    data: null,
    error: action.payload,
  });
}
